import {Injectable} from '@angular/core';
import {EcaseHttpService} from './ecase-http.service';
import {AdminCrmService} from './admin-crm.service';
import {Observable} from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class PersonProfileService {

  constructor(private eCaseHttpService: EcaseHttpService, private adminCrmService: AdminCrmService) {
  }

  private countries: any[] | null = null;

  getCrmCountries(): any[] | null {
    return this.countries;
  }

  setCrmCountries(countries: any[]): void {
    this.countries = countries;
  }

  get emailAddressOfLinkedContact(): any {
    return this.adminCrmService.emailAddressOfLinkedContact;
  }

  set emailAddressOfLinkedContact(value: any) {
    this.adminCrmService.emailAddressOfLinkedContact = value;
  }

  getCrmPerson(personId): Observable<any> {
    return this.eCaseHttpService.get('/api/getCrmPerson/' + personId);
  }

  getCrmPersonEmails(personId): Observable<any> {
    return this.eCaseHttpService.get('/api/getCrmPersonEmails/' + personId);
  }

  getCrmPersonPhones(personId): Observable<any> {
    return this.eCaseHttpService.get('/api/getCrmPersonPhones/' + personId);
  }

  getCrmPersonLocations(personId): Observable<any> {
    return this.eCaseHttpService.get('/api/getCrmPersonLocations/' + personId);
  }

  getCrmPersonProvinces(countryTermId): Observable<any> {
    return this.eCaseHttpService.post('/api/getCrmPersonProvinces', {'countryTermId': countryTermId});
  }

  getCrmPersonWebSites(personId): Observable<any> {
    return this.eCaseHttpService.get('/api/getCrmPersonWebSites/' + personId);
  }

  getCrmPersonIdentities(personId): Observable<any> {
    return this.eCaseHttpService.get('/api/getCrmPersonIdentities/' + personId);
  }

  getCrmPersonLanguages(personId): Observable<any> {
    return this.eCaseHttpService.get('/api/getCrmPersonLanguages/' + personId);
  }

  getCrmPersonBankAccounts(personId): Observable<any> {
    return this.eCaseHttpService.get('/api/getCrmPersonBankAccounts/' + personId);
  }

  getCrmPersonProfileCompleted(personId): Observable<any> {
    return this.eCaseHttpService.get('/api/getCrmPersonProfileCompleted/' + personId);
  }

  addCrmPerson(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/addCrmPerson', obj);
  }

  updateCrmPerson(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/updateCrmPerson', obj);
  }

  validateEmailAddress(emailAddress, isOrg = false): Observable<any> {
    return this.eCaseHttpService.post('/api/validateEmailAddress', {'emailAddress': emailAddress,'isOrg':isOrg});
  }

  addCrmPersonEmail(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/addCrmPersonEmail', obj);
  }

  updateCrmPersonEmail(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/updateCrmPersonEmail', obj);
  }

  deleteCrmPersonEmail(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/deleteCrmPersonEmail', obj);
  }

  addCrmPersonPhone(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/addCrmPersonPhone', obj);
  }

  updateCrmPersonPhone(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/updateCrmPersonPhone', obj);
  }

  deleteCrmPersonPhone(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/deleteCrmPersonPhone', obj);
  }

  changeisPrincipalPhone(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/changeisPrincipalPhone', obj);
  }

  addCrmPersonLocation(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/addCrmPersonLocation', obj);
  }

  updateCrmPersonLocation(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/updateCrmPersonLocation', obj);
  }

  deleteCrmPersonLocation(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/deleteCrmPersonLocation', obj);
  }

  changeisPrincipalLocation(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/changeisPrincipalLocation', obj);
  }

  addCrmPersonWebSite(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/addCrmPersonWebSite', obj);
  }

  updateCrmPersonWebSite(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/updateCrmPersonWebSite', obj);
  }

  deleteCrmPersonWebSite(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/deleteCrmPersonWebSite', obj);
  }

  changeisPrincipalWebSite(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/changeisPrincipalWebSite', obj);
  }

  updateCrmPersonIdentity(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/updateCrmPersonIdentity', obj);
  }

  addCrmPersonLanguage(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/addCrmPersonLanguage', obj);
  }

  deleteCrmPersonLanguage(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/deleteCrmPersonLanguage', obj);
  }

  addCrmPersonBankAccount(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/addCrmPersonBankAccount', obj);
  }

  updateCrmPersonBankAccount(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/updateCrmPersonBankAccount', obj);
  }

  deleteCrmPersonBankAccount(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/deleteCrmPersonBankAccount', obj);
  }

  changeisPrincipalPaymentMethod(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/changeisPrincipalPaymentMethod', obj);
  }

  revokeTrustedDevices(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/revokeTrustedDevices', obj);
  }

  updateCrmPersonProfileCompleted(obj: any): Observable<any> {
    return this.eCaseHttpService.post('/api/updateCrmPersonProfileCompleted', obj);
  }

  getCrmKeyWord(crmPersonId) {
    return this.eCaseHttpService.get(`/api/getCrmPersonKeywords/${crmPersonId}`);
  }

  insertCrmKeyword(objectToInsert) {
    return this.eCaseHttpService.post(`/api/insertCrmPersonKeyword`, objectToInsert);
  }

  createNewTermKeyword(objectToInsert) {
    return this.eCaseHttpService.post(`/api/createNewTermKeyword`, objectToInsert);
  }

  editCrmKeywordComment(objectToInsert) {
    return this.eCaseHttpService.post(`/api/editCrmPersonKeywordComment`, objectToInsert);
  }

  deleteCrmKeyword(objectToInsert) {
    return this.eCaseHttpService.post(`/api/deleteCrmPersonKeyword`, objectToInsert);
  }

  sortLovArrayAlphabetically(sortingArray, selectedLang): any {
    sortingArray = (sortingArray ? sortingArray : []).sort((a, b) => {
      let result = 0;
      try{
        (a.value[selectedLang] === null || a.value[selectedLang] === undefined) ? a.value[selectedLang] = "" : a.value[selectedLang];
        (b.value[selectedLang] === null || b.value[selectedLang] === undefined) ? b.value[selectedLang] = "" : b.value[selectedLang];
        result = (a.value[selectedLang]).toLowerCase().localeCompare((b.value[selectedLang]).toLowerCase());
      }catch(e){
        console.error(e);
      }
      return result;
    });
    return sortingArray;
  }

  sortTermArrayAlphabetically(sortingArray, selectedLang) {
    sortingArray = sortingArray.sort((a, b) => {
      (a.label[selectedLang] === null || a.label[selectedLang] === undefined) ? a.label[selectedLang] = "" : a.label[selectedLang];
      (b.label[selectedLang] === null || b.label[selectedLang] === undefined) ? b.label[selectedLang] = "" : b.label[selectedLang];
      return (a.label[selectedLang]).toLowerCase().localeCompare((b.label[selectedLang]).toLowerCase());

    });
    return sortingArray;
  }

  normalizeTermLabels(terms: any[], selectedLang: string, labelKey: string = 'value'): any[] {
    return (terms || []).map(item => {
      const labels = item[labelKey];
      if (labels && !labels[selectedLang]) {
        const fallback = Object.keys(labels).map(k => labels[k]).find(v => v && v.trim() !== '');
        labels[selectedLang] = fallback || '';
      }
      return item;
    });
  }

  isPrincipalFieldAvailable(dataSet: any[], action: string): boolean {
    console.log(dataSet);
    let isPrincipalOptionAllowed;
    if (action === 'add') {
      if (dataSet.length === 0) {
        isPrincipalOptionAllowed = true;
      } else {
        // dataSet HAS values
        isPrincipalOptionAllowed = !(dataSet.filter(item => item.isPrincipal).map(item => item.isPrincipal)[0]);
        console.log("dataSet HAS values ", isPrincipalOptionAllowed);
      }
    } else {
      // EDIT LOGIC
      isPrincipalOptionAllowed = true;
    }

    return isPrincipalOptionAllowed;
  }

}
